import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg width={80} height={47} viewBox="0 0 80 47" fill="none" {...props}>
      <Path
        d="M20.474 33.743c-3.378 5.258-2.452 11.945-2.452 11.945s6.403-1.837 9.781-7.095c3.379-5.257 2.453-11.944 2.453-11.944s-6.403 1.837-9.782 7.094z"
        fill="#344B3F"
      />
      <Path
        d="M17.905 45.461s-.084-.013-.237-.043a15.6 15.6 0 01-.497-.108c-1.84-.427-6.735-1.872-9.934-5.671C3.232 34.88 3.4 28.235 3.4 28.235s6.123.98 10.158 5.252c.175.184.345.374.51.571 3.484 4.14 3.81 9.708 3.835 11.085.004.206.001.318.001.318z"
        fill="#00D77F"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.578 26.58l-.02.069-.072-.01.012-.082.08.022zm12.437 19.108l-.02.07.08.022.011-.082-.071-.01zM5.619 26.742l-.023.211c-.019.192-.042.473-.06.826-.034.707-.044 1.704.053 2.864.194 2.323.816 5.296 2.527 7.91 1.71 2.616 4.19 4.382 6.243 5.496 1.027.556 1.946.949 2.609 1.202a17.11 17.11 0 00.985.343l.023-.21c.02-.193.043-.473.06-.827a21.96 21.96 0 00-.052-2.864c-.194-2.322-.817-5.295-2.527-7.91-1.711-2.615-4.19-4.381-6.244-5.495a22.125 22.125 0 00-2.608-1.202 16.949 16.949 0 00-.986-.344zm12.396 18.946l.071.01v-.005l.003-.015a6.689 6.689 0 00.031-.28c.02-.195.043-.478.06-.834a22.08 22.08 0 00-.052-2.883c-.195-2.335-.821-5.334-2.55-7.977-1.73-2.643-4.23-4.423-6.296-5.543a22.248 22.248 0 00-2.626-1.21 17.04 17.04 0 00-1.059-.366l-.014-.004-.004-.001h-.001l-.02.069-.072-.01v.005a2.933 2.933 0 00-.01.073l-.024.222c-.019.195-.042.477-.06.833-.035.712-.045 1.715.053 2.884.194 2.335.82 5.334 2.55 7.977 1.729 2.642 4.23 4.423 6.295 5.543 1.034.56 1.959.955 2.626 1.21a17.007 17.007 0 001.06.366l.014.004.005.002.002-.007.018-.063z"
        fill="#3F3D56"
      />
      <Path
        opacity={0.1}
        d="M17.906 45.162c-.088.108-.166.2-.23.276-.142.164-.222.25-.222.25s-.098-.125-.262-.358c-.903-1.278-3.804-5.82-3.58-11.065.012-.275.032-.547.06-.816.17.184.335.375.497.573 3.395 4.16 3.712 9.756 3.737 11.14z"
        fill="#000"
      />
      <Path
        d="M23.106 34.658c-.276 6.196-5.02 11.03-5.02 11.03s-4.297-5.213-4.02-11.409c.276-6.196 5.02-11.03 5.02-11.03s4.297 5.213 4.02 11.409z"
        fill="#00D77F"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.112 23.479l-.907 22.212-.145-.006.907-22.212.145.006z"
        fill="#3F3D56"
      />
      <Path
        d="M23.912 47c13.207 0 23.913-.302 23.913-.674 0-.372-10.706-.673-23.913-.673-13.206 0-23.912.301-23.912.673 0 .372 10.706.674 23.912.674z"
        fill="#344B3F"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.152 39.568v6.12h-.145v-6.12h.145z"
        fill="#3F3D56"
      />
      <Path
        d="M3.967 40.475a.793.793 0 100-1.587.793.793 0 000 1.587z"
        fill="#B0F3AA"
      />
      <Path d="M4.08 43.421s-.127-2.791-2.72-2.467z" fill="#3F3D56" />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.551 19.17v16.772h-.144V19.169h.144z"
        fill="#3F3D56"
      />
      <Path
        d="M24.479 20.302a1.133 1.133 0 100-2.266 1.133 1.133 0 000 2.266z"
        fill="#B0F3AA"
      />
      <Path d="M24.479 23.929s-.169-3.553-3.627-3.14z" fill="#3F3D56" />
      <Path
        d="M46.534 45.9l-15.2-22.262S54.353 31.561 51.74 45.9h-5.207z"
        fill="#344B3F"
      />
      <Path
        d="M46.425 45.9l14.593-22.262s-22.1 7.924-19.592 22.263h5z"
        fill="#00D77F"
      />
      <Path
        d="M42.465 46.725c16.166 0 29.272-.184 29.272-.412 0-.228-13.106-.412-29.272-.412-16.167 0-29.272.184-29.272.412 0 .228 13.105.412 29.272.412z"
        fill="#344B3F"
      />
      <Path
        d="M60.71 46.175l-.517-.01c.2-5.762.814-11.502 1.837-17.176 2.237-12.147 5.958-20.125 11.059-23.712l.297.424C61.47 14.08 60.716 45.855 60.71 46.175zM67.364 46.175l-.574-.01c.013-.551.371-13.549 6.267-17.141l.33.407c-5.658 3.448-6.02 16.611-6.023 16.744z"
        fill="#344B3F"
      />
      <Path
        d="M77.344 5.277a2.639 2.639 0 100-5.277 2.639 2.639 0 000 5.277zM76.024 27.703a2.639 2.639 0 100-5.277 2.639 2.639 0 000 5.277z"
        fill="#EEFF87"
      />
      <Path
        d="M66.665 6.98c.543 3.279-.872 6.211-.872 6.211s-2.295-2.383-2.838-5.662c-.542-3.279.873-6.211.873-6.211S66.121 3.7 66.665 6.98zM75.24 15.17c-2.915 1.268-5.813.318-5.813.318s1.828-3.007 4.743-4.276c2.914-1.268 5.812-.318 5.812-.318s-1.828 3.007-4.743 4.275zM75.106 35.132a6.787 6.787 0 01-4.36.237c.918-1.47 2.153-2.575 3.558-3.182a6.197 6.197 0 014.358-.237c-.943 1.435-2.17 2.532-3.556 3.182z"
        fill="#344B3F"
      />
    </Svg>
  );
}

export default SvgComponent;
